module.exports = __webpack_public_path__ + "img/Flugzeug.b14f47a3.svg";